import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FaSyncAlt } from "react-icons/fa";
import { getAdditionalPaymentLink } from "../services/paymentService";
import styles from "./PaymentStatus.module.css";

const AdditionalPaymentRedirect = () => {
  const { orderId, secureToken } = useParams();
  const [message, setMessage] = useState("Готуємо захищене посилання для доплати.");
  const [paymentUrl, setPaymentUrl] = useState("");

  useEffect(() => {
    let isMounted = true;

    const loadPaymentLink = async () => {
      try {
        const data = await getAdditionalPaymentLink(orderId, secureToken);
        const url =
          data.additionalPaymentProviderUrl ||
          data.providerPaymentUrl ||
          data.paymentUrl;

        if (!url) {
          throw new Error("Платіжне посилання недоступне.");
        }

        if (!isMounted) return;
        setPaymentUrl(url);
        window.location.assign(url);
      } catch (error) {
        if (!isMounted) return;
        setMessage(
          error?.response?.data?.message ||
            error.message ||
            "Не вдалося відкрити доплату."
        );
      }
    };

    loadPaymentLink();

    return () => {
      isMounted = false;
    };
  }, [orderId, secureToken]);

  return (
    <div className={styles.statusPage}>
      <div className={styles.statusPanel}>
        <FaSyncAlt className={styles.icon} />
        <h1 className={styles.title}>Доплата за замовлення</h1>
        <p className={styles.text}>{message}</p>
        {paymentUrl && (
          <div className={styles.actions}>
            <button
              type="button"
              className={styles.button}
              onClick={() => window.location.assign(paymentUrl)}
            >
              Перейти до оплати
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdditionalPaymentRedirect;
